import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const FEATURE_NAME = "tags-feature";
export const PATH_TAGS_FEATURE = FEATURE_NAME;

export const baseActionsPath = `seneca/${FEATURE_NAME}`;

export const tagsCrudConfig: CrudConfig = Object.freeze({
  name: FEATURE_NAME,
  path: `${baseActionsPath}/meta`,
  idFieldName: "id",
  callTypes: [
    AllowedCallTypes.FETCH_ALL,
    AllowedCallTypes.CREATE,
    AllowedCallTypes.UPDATE,
    AllowedCallTypes.DELETE
  ]
});
